var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"job-schedule-team"},[_c('div',{staticClass:"schedule-tab-item-header custom-grey-border p-3"},[_c('JobScheduleTeamHeader')],1),_c('div',{staticClass:"schedule-tab-item-body custom-grey-border p-3"},[_c('JobScheduleTeamBody')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }